import { clone } from '@jkhy/frontend-utils/functions';
import { DashboardWidgetModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

const nullDashboardWidget: DashboardWidgetModelDto = {
    id: 0,
    title: '',
    description: '',
    type: '',
    image: '',
    isResizable: false,
    fullScreenAllowed: false,
    minWidth: 0,
    maxWidth: 0,
    minHeight: 0,
    maxHeight: 0,
    width: 0,
    height: 0,
    left: 0,
    top: 0,
    isRemoved: false,
    hasPermission: false,
    permissionMessage: '',
    isRequired: false,
    updatedBy: '',
    updatedDate: '',
};

export class DashboardWidget extends DomainEntity<DashboardWidgetModelDto> {
    constructor(dto = clone(nullDashboardWidget)) {
        super(dto);
    }

    public createDefault(): this {
        return new DashboardWidget(clone(nullDashboardWidget)) as this;
    }

    public get id() {
        return this.dto.id;
    }

    public get title() {
        return this.dto.title;
    }

    public get type() {
        return this.dto.type;
    }

    public get image() {
        return this.dto.image;
    }

    public get isResizable() {
        return this.dto.isResizable;
    }

    public get fullScreenAllowed() {
        return this.dto.fullScreenAllowed;
    }

    public get minWidth() {
        return this.dto.minWidth;
    }

    public get maxWidth() {
        return this.dto.maxWidth;
    }

    public get minHeight() {
        return this.dto.minHeight;
    }

    public get maxHeight() {
        return this.dto.maxHeight;
    }

    public get width() {
        return this.dto.width;
    }

    public get height() {
        return this.dto.height;
    }

    public get left() {
        return this.dto.left || 0;
    }

    public set left(value: number) {
        this.dto.left = value;
    }

    public get top() {
        return this.dto.top || 0;
    }

    public set top(value: number) {
        this.dto.top = value;
    }

    public get isRemoved() {
        return this.dto.isRemoved || false;
    }

    public set isRemoved(value: boolean) {
        this.dto.isRemoved = value;
    }

    public get hasPermission() {
        return this.dto.hasPermission;
    }

    public get permissionMessage() {
        return this.dto.permissionMessage;
    }

    public get isRequired() {
        return this.dto.isRequired;
    }

    public get updatedBy() {
        return this.dto.updatedBy;
    }

    public get updatedDate() {
        return this.dto.updatedDate;
    }

    public get description() {
        return this.dto.description;
    }
}
